"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvinceListResponseSchema = exports.ProvinceListResultSchema = exports.DistrictListResponseSchema = exports.DistrictListResultSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const schemas_1 = require("../../../../schemas");
const DistrictListItemSchema = schemas_1.DistrictSchema.omit({ provinceCode: true }).extend({
    province: schemas_1.ProvinceSchema.pick({
        code: true,
        id: true,
        localized: true,
        region: true,
    }),
});
exports.DistrictListResultSchema = zod_1.default.object({ districts: DistrictListItemSchema.array() });
exports.DistrictListResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.DistrictListResultSchema);
const ProvinceListItemSchema = schemas_1.ProvinceSchema.pick({
    code: true,
    id: true,
    localized: true,
    region: true,
});
exports.ProvinceListResultSchema = zod_1.default.object({ provinces: ProvinceListItemSchema.array() });
exports.ProvinceListResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.ProvinceListResultSchema);
